module.exports = __webpack_public_path__ + "static/media/person.06871e64.jpeg";